import React, { Component } from 'react';
import './ui-audio-file.scss';
import { connect } from 'react-redux';
import { withApollo } from '@apollo/react-hoc';
import { CheckboxIcon, PauseIcon, PlayIcon, Trashcan } from '../../../assets/icons';
import ReactAudioPlayer from 'react-audio-player';
import UIIcon from '../UIIcon';
import { commonMapDispatchToProps, commonMapStateToProps } from '../../../utils/Helpers/AppHelper';
import PropTypes from 'prop-types';

class UIAudioFile extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isFilePlaying: false
		};

		this.audioRef = React.createRef();
	}

	//Mark: Component functions

	togglePlay = async (e) => {
		e.stopPropagation();
		const { refPool } = this.props;
		const { isFilePlaying } = this.state;

		if (!isFilePlaying) {
			// If a ref pool is being used to pause other instances when this one plays
			if (refPool) {
				pauseAllInRefPool(refPool);
			}
			await this.audioRef['audioEl'].current.play();
		} else {
			this.audioRef['audioEl'].current.pause();
		}
	};

	//Mark: Render functions

	render() {
		const { audioFile, isSelected, selectFile } = this.props;
		const { isFilePlaying } = this.state;
		return (
			<div className='uiAudioFile' key={audioFile.filename} onClick={() => selectFile(audioFile)}>
				<img
					key={isFilePlaying}
					className={isFilePlaying ? 'uiAudioFile__btn' : 'uiAudioFile__btn active-play'}
					src={isFilePlaying ? PauseIcon : PlayIcon.white}
					alt='play/pause button'
					onClick={this.togglePlay}
				/>
				<p className='uiAudioFile__song-name' style={isSelected ? { color: 'var(--mint-primary)' } : undefined}>
					{audioFile.filename}
				</p>
				{isSelected && (
					<div className='uiAudioFile__selected'>
						<UIIcon alt={'remove'} className='uiAudioFile__selected--remove' iconSrc={Trashcan.white} onClick={() => selectFile(undefined)} />
					</div>
				)}

				<ReactAudioPlayer
					id={`music.filename-${audioFile.filename}`}
					src={audioFile.originalUrl}
					controls={false}
					onPause={() => this.setState({ isFilePlaying: false })}
					onPlay={() => this.setState({ isFilePlaying: true })}
					ref={(playerRef) => {
						this.audioRef = playerRef;
						if (playerRef && this.props.refPool.indexOf(this.audioRef) === -1) {
							this.props.addRefToPool(playerRef);
						}
					}}
				/>
			</div>
		);
	}
}

UIAudioFile.propTypes = {
	audioFile: PropTypes.object,
	addRefToPool: PropTypes.func,
	selectFile: PropTypes.func,
	isSelected: PropTypes.bool
};

export default withApollo(connect(commonMapStateToProps, commonMapDispatchToProps)(UIAudioFile));

export function pauseAllInRefPool(refPool) {
	for (let i = 0; i < refPool.length; i++) {
		const ref = refPool[i];
		if (ref['audioEl'].current) {
			ref['audioEl'].current.currentTime = 0;
			ref['audioEl'].current.pause();
		}
	}
}
